import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";
import { Identifiable, ProjectStrategicAxis } from "@planzone/dto";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProjectStrategicAxis(
    request: Boundaries["editProjectStrategicAxis"]["request"],
  ): void;
}

function useEditProjectStrategicAxis(
  projectStrategicAxis: Identifiable<ProjectStrategicAxis>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectStrategicAxisRequestPending(projectStrategicAxis),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectStrategicAxisRequestSuccess(projectStrategicAxis),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectStrategicAxisRequestFailure(projectStrategicAxis),
    ),
    editProjectStrategicAxis: core.editProjectStrategicAxis,
  };
}

export { useEditProjectStrategicAxis };
